import { Injectable } from '@angular/core';
import { ToastService } from './toast.service';
import { EventNotficationMessage } from '../model/eventNotficationMessage';
import { EventType } from '../model/eventtype';

@Injectable()

export class NotificationService {
    constructor(private toastService: ToastService) {
    }

    notifyEventsUpdate(message: EventNotficationMessage) {
        const title = EventType[message.eventType];
        const msg = `${message.residentName} at ${new Date(message.occurrence).toUTCString()}`;
        this.toastService.info(msg, title, 15000);
    }
}